// react
import React, { useState } from 'react'
import { withRouter, useHistory } from 'react-router-dom'
import { If } from 'jsx-control-statements'

// css
import './styles.scss'

// components
import {
  Button,
  BUTTON_THEME,
  Icon,
  Switch,
  Input,
  Select,
} from '@st-operations/uikit/src/v2/index.js'
import { createBrandedAudience } from '_services/partner-branded-audiences'

// functions
import BrandedAudienceSelector from './branded-audiences-selector/index.jsx'
import { logErrorAsync } from '../../lib/utility'

const INITIAL_STATE = {
  //BASIC INFORMATION
  name: '',
  globalId: '',
  usId: '',
  buyable: true,
  //TTD SPECIFIC INFORMATION
  syncTtdGlobal: true,
  syncTtdUs: true,
  ttdShouldInheritRates: true,
  ttdName: '',
  ttdParentGlobalId: '',
  ttdParentUsId: '',
  ttdRateType: 'Hybrid',
  ttdCpmRate: '1.85',
  ttdPercentOfMediaCostRate: '0.2',
  //APPNEXUS SPECIFIC INFORMATION
  syncAppnexusGlobal: true,
  syncAppnexusUs: true,
  appnexusGlobalName: '',
  appnexusUsName: '',
  appnexusCpmRate: '0.95',
}

const STEPS = {
  one: {
    order: 1,
    title: 'Basic Information',
  },
  two: {
    order: 2,
    title: 'TTD Specific Information',
  },
  three: {
    order: 3,
    title: 'AppNexus Specific Information',
  },
}

const isNumberOrEmpty = (str) => str.length === 0 || (!isNaN(str) && !isNaN(parseFloat(str)))

const PartnerBrandedAudiencesModal = ({ onClose }) => {
  const [step, setStep] = useState(1)
  const isLastStep = step === STEPS.three.order
  const numberOfSteps = Object.keys(STEPS).length
  const [isLoading, setIsLoading] = useState(false)
  //BASIC INFORMATION
  const [name, setName] = useState('')
  const [audience, setAudience] = useState('')
  const [buyable, setBuyable] = useState(INITIAL_STATE.buyable)
  const [globalId, setGlobalId] = useState(INITIAL_STATE.globalId)
  const [usId, setUsId] = useState(INITIAL_STATE.usId)
  //TTD SPECIFIC INFORMATION
  const [syncTtdGlobal, setSyncTtdGlobal] = useState(INITIAL_STATE.syncTtdGlobal)
  const [syncTtdUs, setSyncTtdUs] = useState(INITIAL_STATE.syncTtdUs)
  const [ttdShouldInheritRates, setTtdShouldInheritRates] = useState(
    INITIAL_STATE.ttdShouldInheritRates
  )
  const [ttdName, setTtdName] = useState(INITIAL_STATE.ttdName)
  const [ttdParentGlobalId, setTtdParentGlobalId] = useState(INITIAL_STATE.ttdParentGlobalId)
  const [ttdParentUsId, setTtdParentUsId] = useState(INITIAL_STATE.ttdParentUsId)
  const [ttdRateType, setTtdRateType] = useState(INITIAL_STATE.ttdRateType)
  const [ttdCpmRate, setTtdCpmRate] = useState(INITIAL_STATE.ttdCpmRate)
  const [ttdPercentOfMediaCostRate, setTtdPercentOfMediaCostRate] = useState(
    INITIAL_STATE.ttdPercentOfMediaCostRate
  )
  //APPNEXUS SPECIFIC INFORMATION
  const [syncAppnexusGlobal, setSyncAppnexusGlobal] = useState(INITIAL_STATE.syncAppnexusGlobal)
  const [syncAppnexusUs, setSyncAppnexusUs] = useState(INITIAL_STATE.syncAppnexusUs)
  const [appnexusGlobalName, setAppnexusGlobalName] = useState(INITIAL_STATE.appnexusGlobalName)
  const [appnexusUsName, setAppnexusUsName] = useState(INITIAL_STATE.appnexusUsName)
  const [appnexusCpmRate, setAppnexusCpmRate] = useState(INITIAL_STATE.appnexusCpmRate)

  //ACTIVE/DESACTIVE THE INPUTS TTD and APPNEXUS
  const [disabledInputTtdGlobal, setDisabledInputTtdGlobal] = useState(false)
  const [disabledInputTtdUS, setDisabledInputTtdUS] = useState(false)
  const [disabledInputAppnexusGlobal, setDisabledInputAppnexusGlobal] = useState(false)
  const [disabledInputAppnexusUs, setDisabledInputAppnexusUs] = useState(false)

  const history = useHistory()

  const create = async () => {
    setIsLoading(true)
    try {
      const response = await createBrandedAudience({
        //BASIC INFORMATION
        name,
        globalId,
        usId,
        buyable,
        //TTD SPECIFIC INFORMATION
        syncTtdGlobal,
        syncTtdUs,
        ttdShouldInheritRates,
        ttdName,
        ttdParentGlobalId,
        ttdParentUsId,
        ttdRateType,
        ttdCpmRate,
        ttdPercentOfMediaCostRate,
        //APPNEXUS SPECIFIC INFORMATION
        syncAppnexusGlobal,
        syncAppnexusUs,
        appnexusGlobalName,
        appnexusUsName,
        appnexusCpmRate,
      })
      onClose()
      // eslint-disable-next-line no-debugger
      debugger
      history.push(`partner-branded-audiences/${response._id}`)
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
    setIsLoading(false)
  }

  const handleNextClick = () => {
    setStep((prevStep) => prevStep + 1)
  }

  const handleBackClick = () => {
    setStep((prevStep) => prevStep - 1)
  }

  const getTitle = (currentStep) => {
    const step = Object.values(STEPS).find((step) => step.order === currentStep)
    return step.title
  }

  const handleBuyable = () => {
    setBuyable((prevState) => !prevState)
  }

  const handleSyncTtdGlobal = () => {
    setSyncTtdGlobal((prevState) => !prevState)
    setDisabledInputTtdGlobal((prevState) => !prevState)
  }

  const handleSyncTtdUS = () => {
    setSyncTtdUs((prevState) => !prevState)
    setDisabledInputTtdUS((prevState) => !prevState)
  }

  const handleInheritRates = () => {
    setTtdShouldInheritRates((prevState) => !prevState)
  }

  const handleSyncAppnexusGlobal = () => {
    setSyncAppnexusGlobal((prevState) => !prevState)
    setDisabledInputAppnexusGlobal((prevState) => !prevState)
  }

  const handleSyncAppnexusUs = () => {
    setSyncAppnexusUs((prevState) => !prevState)
    setDisabledInputAppnexusUs((prevState) => !prevState)
  }

  //AUDIENCE CAN BE NULL, OBJECT OR TEXT
  const onChangeAudience = (audience) => {
    setAudience(audience)
    setName(audience?.name || audience)

    const nameParts = audience?.name?.split('>')
    const ttdName = nameParts?.[nameParts.length - 1]?.trim()

    setGlobalId(audience?.ids?.global || '')
    setUsId(audience?.ids?.us || '')

    setTtdName(ttdName)

    setAppnexusGlobalName(audience?.name && `ShareThis > ${audience.name}`)
    setAppnexusUsName(audience?.name && `ShareThis_US > ${audience.name}`)
  }

  return (
    <div className="partner-branded-audiences-modal">
      <div
        className="partner-branded-audiences-modal__bar"
        style={{ width: `${(step / numberOfSteps) * 100}%` }}
      />
      <header className="partner-branded-audiences-modal__header">
        <button
          arial-label="Close modal"
          className="partner-branded-audiences-modal__close"
          onClick={onClose}
        >
          <Icon color="#000" height="16px" icon="delete" type="fill" width="16px" />
        </button>
        <div className="partner-branded-audiences-modal__step">
          Step {step} of {numberOfSteps}
        </div>
        <p className="partner-branded-audiences-modal__title">{getTitle(step)}</p>
      </header>
      <div>
        <If condition={step === STEPS.one.order}>
          <BrandedAudienceSelector value={audience} onChange={onChangeAudience} />
          <Input label="Global ID" onChange={(value) => setGlobalId(value)} value={globalId} />
          <Input label="US ID" onChange={(value) => setUsId(value)} value={usId} />
          <div className="partner-branded-audiences-modal__switch-wrapper">
            <p className="partner-branded-audiences-modal__label">Buyable</p>
            <Switch checked={buyable} onChange={handleBuyable} />
          </div>
        </If>

        <If condition={step === STEPS.two.order}>
          <div className="partner-branded-audiences-modal__switch-row">
            <p className="partner-branded-audiences-modal__label ">Sync</p>
            <p className="partner-branded-audiences-modal__label partner-branded-audiences-modal__label-normal">
              Global
            </p>
            <Switch checked={syncTtdGlobal} onChange={handleSyncTtdGlobal} />
            <p className="partner-branded-audiences-modal__label partner-branded-audiences-modal__label-normal">
              US
            </p>
            <Switch checked={syncTtdUs} onChange={handleSyncTtdUS} />
            <p
              className="partner-branded-audiences-modal__label
            partner-branded-audiences-modal__label-normal
            partner-branded-audiences-modal__last-label"
            >
              Inherit rates
            </p>
            <Switch checked={ttdShouldInheritRates} onChange={handleInheritRates} />
          </div>
          <Input
            label="TTD Name"
            onChange={(value) => setTtdName(value)}
            value={ttdName}
            disabled={disabledInputTtdGlobal && disabledInputTtdUS}
          />
          <Input
            label="TTD Parent Global ID"
            onChange={setTtdParentGlobalId}
            value={ttdParentGlobalId}
            disabled={disabledInputTtdGlobal}
          />
          <Input
            label="​​TTD Parent US ID"
            onChange={(value) => setTtdParentUsId(value)}
            value={ttdParentUsId}
            disabled={disabledInputTtdUS}
          />
          <If condition={!ttdShouldInheritRates}>
            <h2 className="partner-branded-audiences-modal__title">
              TTD Rate Types And Their Options
            </h2>
            <Select
              label="TDD Rate Type"
              options={['CPM', 'Hybrid', 'Percent Of Media Cost']}
              value={ttdRateType}
              onChange={(value) => setTtdRateType(value)}
              containerStyle={{ marginBottom: 20 }}
            />
            <If condition={['Hybrid', 'CPM'].includes(ttdRateType)}>
              <Input
                label="TDD CPM Rate"
                value={ttdCpmRate}
                onChange={(value) => setTtdCpmRate(value)}
                errorMessage={
                  !isNumberOrEmpty(ttdCpmRate) ? 'The value is not a number' : undefined
                }
              />
            </If>
            <If condition={['Hybrid', 'Percent Of Media Cost'].includes(ttdRateType)}>
              <Input
                label="TDD Percent of Media Cost Rate"
                value={ttdPercentOfMediaCostRate}
                onChange={(value) => setTtdPercentOfMediaCostRate(value)}
                errorMessage={
                  !isNumberOrEmpty(ttdPercentOfMediaCostRate)
                    ? 'The value is not a number'
                    : undefined
                }
              />
            </If>
          </If>
        </If>
      </div>

      <If condition={step === STEPS.three.order}>
        <div className="partner-branded-audiences-modal__switch-nexus-row">
          <p className="partner-branded-audiences-modal__label ">Sync</p>
          <p className="partner-branded-audiences-modal__label partner-branded-audiences-modal__label-normal">
            AppNexus Global
          </p>
          <Switch checked={syncAppnexusGlobal} onChange={handleSyncAppnexusGlobal} />
          <p className="partner-branded-audiences-modal__label partner-branded-audiences-modal__label-normal">
            AppNexus US
          </p>
          <Switch checked={syncAppnexusUs} onChange={handleSyncAppnexusUs} />
        </div>
        <Input
          label="AppNexus Global Name"
          value={appnexusGlobalName}
          onChange={(value) => setAppnexusGlobalName(value)}
          disabled={disabledInputAppnexusGlobal}
        />
        <Input
          label="AppNexus US Name"
          value={appnexusUsName}
          onChange={(value) => setAppnexusUsName(value)}
          disabled={disabledInputAppnexusUs}
        />
        <Input
          label="​​AppNexus CPM Rate"
          value={appnexusCpmRate}
          onChange={(value) => setAppnexusCpmRate(value)}
          errorMessage={!isNumberOrEmpty(appnexusCpmRate) ? 'The value is not a number' : undefined}
          disabled={disabledInputAppnexusGlobal && disabledInputAppnexusUs}
        />
      </If>

      <div className="partner-branded-audiences-modal__buttons">
        <If condition={step > 1}>
          <Button
            className="partner-branded-audiences-modal__button"
            onClick={handleBackClick}
            theme={BUTTON_THEME.SECONDARY}
          >
            Back
          </Button>
        </If>
        <Button
          className="partner-branded-audiences-modal__button"
          onClick={isLastStep ? create : handleNextClick}
          isLoading={isLoading}
          disabled={
            isLoading ||
            !audience ||
            !isNumberOrEmpty(ttdCpmRate) ||
            !isNumberOrEmpty(ttdPercentOfMediaCostRate) ||
            !isNumberOrEmpty(appnexusCpmRate)
          }
        >
          {isLastStep ? 'Create' : 'Next'}
        </Button>
      </div>
    </div>
  )
}

export default withRouter(PartnerBrandedAudiencesModal)
